<div class="connection-card" *ngIf="connection">

    <div class="left">
        <div class="feature-square">
            <app-svg-loader *ngIf="connection.status === 'pending'" url="assets/svg/inbox-solid.svg"></app-svg-loader>
            <app-svg-loader *ngIf="connection.status !== 'pending'" url="assets/svg/flight-shape-solid.svg"></app-svg-loader>
        </div>
        <div class="info">
            <div class="flight-locations">
                {{friendlyRoute}}
            </div>
            <div class="user-name">
                with {{otherUserName}}
            </div>
             <div class="review-button" *ngIf="isFlightReadyToReview()" (click)="showReview($event)">
             <app-svg-loader height="12px" url="assets/svg/star-solid.svg"></app-svg-loader>
             <div>Review Flight</div>
        </div>
        </div>
    </div>

    <div class="right">
        <div class="utility-row" *ngIf="connection.status === 'confirmed'">
            <!-- // TODO: WIRE UP UNREAD -->
            <div class="utility-text">
                1 Unread
            </div>
            <div class="utility-icon">
                <app-svg-loader url="assets/svg/messages-solid.svg"></app-svg-loader>
            </div>
        </div>
        <div class="utility-row" *ngIf="connection.status === 'pending'">
            <div class="utility-text">
                {{viewedAt ? viewedAt : 'Not Reviewed'}}
            </div>
            <div class="utility-dot" [ngClass]="{'viewed': viewedAt}"></div>
        </div>
    </div>

</div>

<app-pop-tray *ngIf="showReviewTray" [header]="'Review User'" [description]="'How was your experience with this party?'"
    [actions]="reviewActions">
    <app-star-rating [(rating)]="reviewRating"></app-star-rating>
    <app-base-text-area mt="16px" mb="18px" placeholder="Feedback (optional)" isFluid="true"
        [(ngModel)]="reviewText"></app-base-text-area>
</app-pop-tray>
